import axios from 'axios';

import { CLA } from 'components/types';

import { EMPLOYEES_CLAS } from 'RestAPIs/endpoints';

export const getClas = (costCenterId: number, validOn: string) =>
  axios.get<CLA[]>(EMPLOYEES_CLAS, {
    params: { costCenterId, validOn }
  });
